import moment from "moment/moment";
import {Card, Col, Row} from "react-bootstrap";
import {QuickPayRequestMap} from "../../../../utils/helpers/mappers";
import {formatAmountToString, toTitleCase} from "../../../../utils/helpers/logicHelper";

type Props = {
  request: IQuickPaymentRequest[],
  extras: IDriverExtras
}

const QuickPayRequestBreakdown = ({request, extras}: Props) => {
  return (
    <Col md={7} xl={8} className="h-auto">
      <Card className="mb-4">
        <Card.Body>
          <div className="d-flex justify-content-between border-bottom pb-3">
            {/* <h5 className="mb-1">{request[0]?.id ?? ""}</h5> */}
            <span className={`badge rounded-pill m-1 
                    ${(request && QuickPayRequestMap[request[0].status]) ? QuickPayRequestMap[request[0].status].fill : "bg-secondary"} font-size-14`}>
                      {(request && request[0].status) ? QuickPayRequestMap[request[0]?.status].label : "INITIATED"}
                    </span>
          </div>

          <Row className="mt-4">
            <Col md={12} lg={6} className="mb-4">
              <span className="fw-bold">Quick-Pay Use:</span>
              <span
                className="ms-2">{request[0]?.reason ?? "-"}</span>
            </Col>
            <Col md={12} lg={6} className="mb-4">
              <span className="fw-bold">Quick-Pay Amount:</span>
              <span className="ms-2">{formatAmountToString(request[0]?.amount) ?? 0}</span>
            </Col>
            {/* <Col md={12} lg={6} className="mb-4">
              <span className="fw-bold">Repayment Amount:</span>
              <span className="ms-2">{formatAmountToString(request?.repayment_amount ?? 0)}</span>
            </Col> */}
            {/* <Col md={12} lg={6} className="mb-4">
              <span className="fw-bold">Repayed Amount:</span>
              <span className="ms-2">{formatAmountToString(request?.repayed_amount ?? 0)}</span>
            </Col> */}
            {/* <Col md={12} lg={6} className="mb-4">
              <span className="fw-bold">Balance:</span>
              <span className="ms-2">{formatAmountToString(request?.balance ?? 0)}</span>
            </Col> */}
            {/* <Col md={12} lg={6} className="mb-4">
              <span className="fw-bold">Repayment Due Date:</span>
              <span className="ms-2">{moment(request?.due_date).format('lll') ?? "-"}</span>
            </Col> */}
          </Row>
        </Card.Body>
      </Card>
      <Card>
        <Card.Body>
          <div className="d-flex justify-content-between border-bottom pb-3">
            <h5 className="mb-1">More User Information</h5>
          </div>
          <Row className="mt-4">
            <Col md={12} lg={6} className="mb-4">
              <span className="fw-bold">Address:</span>
              <span
                className="ms-2">{toTitleCase(extras.address) ?? ""}</span>
            </Col>
            <Col md={12} lg={6} className="mb-4">
              <span className="fw-bold">Date of Birth:</span>
              <span className="ms-2">{moment(extras.date_of_birth).format('lll') ?? "-"}</span>
            </Col>
            <Col md={12} lg={6} className="mb-4">
              <span className="fw-bold">License Number:</span>
              <span className="ms-2">{extras.license_number ?? "-"}</span>
            </Col>
            <Col md={12} lg={6} className="mb-4">
              <span className="fw-bold">License Expiry:</span>
              <span className="ms-2">{moment(extras.license_expires_on).format('lll') ?? "-"}</span>
            </Col>
            <Col md={12} lg={6} className="mb-4">
              <span className="fw-bold">Guarantor Name:</span>
              <span className="ms-2">{toTitleCase(extras.guarantor_full_name_) ?? "-"}</span>
            </Col>
            <Col md={12} lg={6} className="mb-4">
              <span className="fw-bold">Guarantor Email Address:</span>
              <span className="ms-2">{extras.guarantor_email_address ?? "-"}</span>
            </Col>
            <Col md={12} lg={6} className="mb-4">
              <span className="fw-bold">Guarantor House Address:</span>
              <span className="ms-2">{toTitleCase(extras.guarantor_house_address) ?? "-"}</span>
            </Col>
            <Col md={12} lg={6} className="mb-4">
              <span className="fw-bold">Guarantor Phone Number:</span>
              <span className="ms-2">{extras.guarantor_phone_number ?? "-"}</span>
            </Col>
          </Row>
          {/* <Row className="mt-4">
            {(extras) &&
              dynamicFields.map((item) =>
                <Fragment key={item.key}>
                  {(item.key in request.driver.dynamic_fields && (item.type !== InputType.FILE && item.type !== InputType.BOOLEAN)) &&
										<Col md={12} lg={6} className="mb-4">
											<span className="fw-bold">{toTitleCase(item.key)}</span>
											<span className="ms-2">
                            {(item.type !== InputType.DATE && request.driver.dynamic_fields[item.key]) ? toTitleCase(request.driver.dynamic_fields[item.key])
                              : (item.type === InputType.DATE && request.driver.dynamic_fields[item.key] && moment(request.driver.dynamic_fields[item.key]).isValid())
                                ? moment(request.driver.dynamic_fields[item.key]).format('D-MMMM-YYYY')
                                : "-"
                            }
                          </span>
										</Col>
                  }
                </Fragment>
              )}
          </Row> */}
        </Card.Body>
      </Card>
    </Col>
  )
}

export default QuickPayRequestBreakdown